import ProjectTile from "../Components/ProjectTile.js";
import React from "react";
import { projectsData } from "../Components/ProjectBlueprint.js";

const projectDisplayOrder = [
  "dont-leave-me",
  "eggventure",
  "glitch-burst",
  "triffids",
  "drive-or-die",
  "dashing-joy",
  "mini-me",
  "project-x",
  "world-evolution",
  "age-of-snails",
];

export default function Projects() {
  const orderedProjects = [...projectsData].sort((firstProject, secondProject) => {
    const firstIndex = projectDisplayOrder.indexOf(firstProject.id);
    const secondIndex = projectDisplayOrder.indexOf(secondProject.id);

    if (firstIndex === -1 && secondIndex === -1) return 0;
    if (firstIndex === -1) return 1;
    if (secondIndex === -1) return -1;
    return firstIndex - secondIndex;
  });

  return (
    <div>
      <div>
        <h1 id="projectsTitle">Projects</h1>
      </div>

      <div className="projectsContainer">
        <div className="projects">
          <ul>
            {orderedProjects.map((project) => {
              const isDevMode = window.location.pathname === "/projects/dev";
              const shouldShow = !project.hidden || isDevMode;

              if (shouldShow) {
                return (
                  <li className="project" key={project.id}>
                    <ProjectTile
                      projectId={project.id}
                      title={project.title}
                      description={project.shortDescription}
                      link={`/projects/${project.id}`}
                      imageSrc={project.tileThumbnail}
                      technologies={project.technologies}
                    />
                  </li>
                );
              }
              return null;
            })}
          </ul>
        </div>
      </div>
    </div>
  );
}
